module.exports = __webpack_public_path__ + "img/il.2ed461d2.svg";